const orderedTime = [
  { text: "Select", value: "" },
  { text: "Last Week", value: "LAST_WEEK" },
  { text: "Last Month", value: "LAST_MONTH" },
  { text: "Last 3 Months", value: "LAST_3_MONTHS" },
  { text: "Last Year", value: "LAST_YEAR" }
];

const filterOperatorOptions = function(currentFilters, currentFilter) {
  const defaultFilters = [
    { text: "Select Operator", value: "" },
    { text: "Equals", value: "EQUALS" },
    { text: "Not Equals", value: "NOT_EQUALS" },
    { text: "Greater Than", value: "GREATER_THAN" },
    { text: "Less Than", value: "LESS_THAN" },
    { text: "Greater or Equal to", value: "GREATER_OR_EQUAL_TO" },
    { text: "Less or Equal to", value: "LESS_OR_EQUAL_TO" }
  ];

  if (currentFilter.field === "COUNTRY") {
    return [
      { text: "Select Operator", value: "" },
      { text: "Equals", value: "EQUALS" },
      { text: "Not Equals", value: "NOT_EQUALS" }
    ];
  }

  if (currentFilter.field === "ORDERED") {
    return [
      { text: "Select Operator", value: "" },
      { text: "Has placed an order within", value: "EQUALS" },
      { text: "Has not placed an order within", value: "NOT_EQUALS" }
    ];
  }

  if (currentFilter.field === "TAG") {
    return [
      { text: "Select Operator", value: "" },
      { text: "Has tag", value: "EQUALS" },
      { text: "Does not have tag", value: "NOT_EQUALS" }
    ];
  }

  currentFilters.map(filter => {
    let equalsFilter = 0;
    let notEqualsFilter = 0;
    let greaterThanFilter = 0;
    let lessThanFilter = 0;
    let greaterOrEqualToFilter = 0;
    let lessOrEqualToFilter = 0;

    console.log(filter);
    if (filter.field === "ORDER_COUNT" || filter.field === "TOTAL_SPENT") {
      if (filter.operator === "EQUALS" && currentFilter.field === filter.field) {
        equalsFilter = equalsFilter + 1;
      }
      if (
        filter.operator === "NOT_EQUALS" &&
        currentFilter.field === filter.field
      ) {
        notEqualsFilter = notEqualsFilter + 1;
      }
      if (
        filter.operator === "GREATER_THAN" &&
        currentFilter.field === filter.field
      ) {
        greaterThanFilter = greaterThanFilter + 1;
      }
      if (
        filter.operator === "LESS_THAN" &&
        currentFilter.field === filter.field
      ) {
        lessThanFilter = lessThanFilter + 1;
      }
      if (
        filter.operator === "GREATER_OR_EQUAL_TO" &&
        currentFilter.field === filter.field
      ) {
        greaterOrEqualToFilter = greaterOrEqualToFilter + 1;
      }
      if (
        filter.operator === "LESS_OR_EQUAL_TO" &&
        currentFilter.field === filter.field
      ) {
        lessOrEqualToFilter = lessOrEqualToFilter + 1;
      }

      if (
        equalsFilter >= 1 &&
        currentFilter.operator !== "EQUALS" &&
        currentFilter.field === filter.field
      ) {
        defaultFilters.map((defaultFilter, index) => {
          if (defaultFilter.value === "EQUALS") {
            defaultFilters.splice(index, 1);
          }
        });
      }
      if (
        notEqualsFilter >= 1 &&
        currentFilter.operator !== "NOT_EQUALS" &&
        currentFilter.field === filter.field
      ) {
        defaultFilters.map((defaultFilter, index) => {
          if (defaultFilter.value === "NOT_EQUALS") {
            defaultFilters.splice(index, 1);
          }
        });
      }
      if (
        greaterThanFilter >= 1 &&
        currentFilter.operator !== "GREATER_THAN" &&
        currentFilter.field === filter.field
      ) {
        defaultFilters.map((defaultFilter, index) => {
          if (defaultFilter.value === "GREATER_THAN") {
            defaultFilters.splice(index, 1);
          }
        });
      }
      if (
        lessThanFilter >= 1 &&
        currentFilter.operator !== "LESS_THAN" &&
        currentFilter.field === filter.field
      ) {
        defaultFilters.map((defaultFilter, index) => {
          if (defaultFilter.value === "LESS_THAN") {
            defaultFilters.splice(index, 1);
          }
        });
      }
      if (
        greaterOrEqualToFilter >= 1 &&
        currentFilter.operator !== "GREATER_OR_EQUAL_TO" &&
        currentFilter.field === filter.field
      ) {
        defaultFilters.map((defaultFilter, index) => {
          if (defaultFilter.value === "GREATER_OR_EQUAL_TO") {
            defaultFilters.splice(index, 1);
          }
        });
      }
      if (
        lessOrEqualToFilter >= 1 &&
        currentFilter.operator !== "LESS_OR_EQUAL_TO" &&
        currentFilter.field === filter.field
      ) {
        defaultFilters.map((defaultFilter, index) => {
          if (defaultFilter.value === "LESS_OR_EQUAL_TO") {
            defaultFilters.splice(index, 1);
          }
        });
      }
    }
  });

  return defaultFilters;
};

const filterTypeOptions = function(filters, filter) {
  const defaultFilters = [
    { text: "Select Type", value: "" },
    { text: "Country", value: "COUNTRY" },
    { text: "Ordered", value: "ORDERED" },
    { text: "Order Count", value: "ORDER_COUNT" },
    { text: "Total Spent", value: "TOTAL_SPENT" },
    { text: "Tag", value: "TAG" }
  ];

  let countryFilter = 0;
  let orderedFilter = 0;
  let tagFilter = 0;

  filters.map(filter => {
    if (filter.field === "COUNTRY") {
      countryFilter = countryFilter + 1;
    }
    if (filter.field === "ORDERED") {
      orderedFilter = orderedFilter + 1;
    }
    if (filter.field === "TAG") {
      tagFilter = tagFilter + 1;
    }
  });

  if (countryFilter >= 1 && filter.field !== "COUNTRY") {
    defaultFilters.map((filter, index) => {
      if (filter.value === "COUNTRY") {
        defaultFilters.splice(index, 1);
      }
    });
  }
  if (orderedFilter >= 1 && filter.field !== "ORDERED") {
    defaultFilters.map((filter, index) => {
      if (filter.value === "ORDERED") {
        defaultFilters.splice(index, 1);
      }
    });
  }
  if (tagFilter >= 1 && filter.field !== "TAG") {
    defaultFilters.map((filter, index) => {
      if (filter.value === "TAG") {
        defaultFilters.splice(index, 1);
      }
    });
  }

  return defaultFilters;
};

export { orderedTime, filterOperatorOptions, filterTypeOptions };
